module.exports = __webpack_public_path__ + "img/software.bb100ba2.png";